<template>
    <div class="button-inline">
        <el-button type="success" :plain="true" icon="el-icon-my-youjian color-success"
                   @click="$emit('sendEmail', 4)">
            通知供应商
        </el-button>
        <el-button type="primary" :plain="true" icon="el-icon-my-youjian color-primary"
                   @click="$emit('sendEmail', 1)">
            通知应聘者
        </el-button>
        <el-button type="warning" :plain="true" icon="el-icon-my-youjian color-warning"
                   @click="$emit('sendEmail', 2)">
            通知面试官
        </el-button>
    </div>
</template>
<script type="text/javascript">
    export default {
        data () {
            return {}
        }
    }
</script>
<style type="text/css" lang="scss" scoped="">
    @import "~variable";

    .button-inline {
        display : inline-block;
    }
</style>


// WEBPACK FOOTER //
// arrangeCommon.vue?20f49ca0